import { render, staticRenderFns } from "./RelatorioRepasseTaxas.vue?vue&type=template&id=1c2aac98&scoped=true&"
import script from "./RelatorioRepasseTaxas.vue?vue&type=script&lang=js&"
export * from "./RelatorioRepasseTaxas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2aac98",
  null
  
)

export default component.exports